import type { AgentContext, ConsentState } from "../types";

let agentContext: AgentContext = {};
let consentState: ConsentState = { analytics: true, marketing: false };

export function initContextFromWindow(): void {
  const w = typeof window !== "undefined" ? window : (undefined as unknown as Window);
  if (w && w.__X_CONTEXT__) {
    agentContext = { ...w.__X_CONTEXT__ };
  }
}

export function getAgentContext(): AgentContext {
  return { ...agentContext };
}

export function setAgentContext(ctx: AgentContext): void {
  agentContext = { ...agentContext, ...ctx };
}

export function getConsent(): ConsentState {
  return { ...consentState };
}

export function setConsent(state: ConsentState): void {
  consentState = { ...consentState, ...state };
}

export function shouldPersistIdentity(consentMode: "none" | "optional" | "required"): boolean {
  if (consentMode === "none") return true;
  return consentState.analytics === true;
}
